import { render, staticRenderFns } from "./NetworkService.vue?vue&type=template&id=05f69152"
import script from "./NetworkService.vue?vue&type=script&lang=js"
export * from "./NetworkService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f69152')) {
      api.createRecord('05f69152', component.options)
    } else {
      api.reload('05f69152', component.options)
    }
    module.hot.accept("./NetworkService.vue?vue&type=template&id=05f69152", function () {
      api.rerender('05f69152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NetworkService.vue"
export default component.exports